import { render, staticRenderFns } from "./pageContainer.vue?vue&type=template&id=734ed833&scoped=true"
import script from "./pageContainer.vue?vue&type=script&lang=js"
export * from "./pageContainer.vue?vue&type=script&lang=js"
import style0 from "./pageContainer.vue?vue&type=style&index=0&id=734ed833&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734ed833",
  null
  
)

export default component.exports